module.exports = __webpack_public_path__ + "img/Simple-Software-logo.586a4e2f.jpg";